<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="contacts"
      :search="textSearch"
      :pagination.sync="itemsPerPageOptions"
      :total-items="totalContacts"
      :loading="loadContacts"
      :rows-per-page-items="rowsPerPageSelect"
    >
    
      <template slot="items" slot-scope="props">
        <td>
          <v-tooltip top v-if="props.item.is_filled">
            <v-btn slot="activator" icon>
              <v-icon color="green" size="16">how_to_reg</v-icon>
            </v-btn>
            <span>The information of this contact is complete.</span>
          </v-tooltip>
          <v-tooltip top v-else>
            <v-btn slot="activator" icon @click="editItem(props.item)">
              <v-icon color="red" size="16">how_to_reg</v-icon>
            </v-btn>
            <span>Incomplete information.</span>
          </v-tooltip>
        </td>
        <td> {{ props.item.name }} </td>
        <td> {{ props.item.email }} </td>
        <td> {{ props.item.position }} </td>
        <td> {{ props.item.seniority }} </td>
        <td> {{ props.item.priority }} </td>
        <td> {{ props.item.company }} </td>
        <td> {{ props.item.country }} </td>
        <td> {{ props.item.segmentation }} </td>
        <td> {{ props.item.segmentation2 }} </td>
        <td> {{ props.item.tag }} </td>
        <td class="justify-center layout px-0">
          <v-btn fab flat small color="primary mr-1" @click="editContact(props.item)">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn fab flat small color="red" @click="openModalDelete(props.item)" :disabled="props.item.removable">
            <v-icon small >delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <modal-edit-contact
      v-if="showModalEditContact"
      :showModal="showModalEditContact"
      @close-modal-edit-contact="resetShowModals"
      :contactId="selectedContact.id"
      @update-contact="loadData"
    > </modal-edit-contact>

     <modal-delete-contact
      v-if="showModalDeleteContact"
      :showModal="showModalDeleteContact"
      @close-modal-delete-contact="resetShowModals"
      @delete-contact="loadData"
      :contact="selectedContact"
    > </modal-delete-contact>

  </div>
</template>

<script>
import ModalEditContact from '@/components/client/contacts/components/modals/EditContact.vue';
import ModalDeleteContact from '@/components/client/contacts/components/modals/DeleteContact.vue';

export default {
  components: {
    ModalEditContact,
    ModalDeleteContact
  },
  props: {
    textSearch: {
      type: String,
      default: ''  
    },
    totalContacts: {
      type: Number,
      default: 0
    },
    loadContacts: {
      type: Boolean,
      default: false
    },
    contacts: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      headers: [
        { text: null, value: 'is_filled', sortable: false },
        { text: 'Name', align: 'left', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Segmentation 1', value: 'position', sortable: false },
        { text: 'Segmentation 2', value: 'seniority', sortable: false },
        { text: 'Segmentation 3', value: 'priority', sortable: false },
        { text: 'Segmentation 4', value: 'company', sortable: false },
        { text: 'Segmentation 5', value: 'country', sortable: false },
        { text: 'Segmentation 6', value: 'segmentation', sortable: false },
        { text: 'Segmentation 7', value: 'segmentation2', sortable: false },
        { text: 'Segmentation 8', value: 'tag', sortable: false },
        { text: 'Actions', value: null, sortable: false },
      ],
      itemsPerPageOptions: {
        descending: false,
        page: 1,
        rowsPerPage: 5,
        sortBy: ''
      },
      rowsPerPageSelect: [5, 10, 25],
      showModalEditContact: false,
      showModalDeleteContact: false,
      selectedContact: null
      
    };
  },
  
  watch: {
    itemsPerPageOptions () {
      this.$emit('update-data', this.itemsPerPageOptions);
    },
    textSearch (newValue, oldValue) {
      if (this.itemsPerPageOptions.page > 1) {
        this.itemsPerPageOptions.page = 1;
        return;
      }
      if (newValue.length > 3 || newValue === '') {
        this.$emit('update-data', this.itemsPerPageOptions);
      }
    },
  },
  methods: {
    editContact (contact) {
      this.showModalEditContact = true;
      this.selectedContact = contact;
    },
    openModalDelete (contact) {
      this.showModalDeleteContact = true;
      this.selectedContact = contact;
    },
    resetShowModals () {
      this.showModalEditContact = false;
      this.showModalDeleteContact = false;
      this.showModalUpload = false;
      this.selectedContact = null;
    },
    
    loadData () {
      this.$emit('update-data', this.itemsPerPageOptions);
    }
  } 
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/client/contacts/components/ContactsTable.vue